import {
    faCheckCircle,
    faCircleInfo,
    faExclamationTriangle,
    faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./guidance-callout.scss";

const VARIANT_CONFIG = {
    warning: {
        icon: faExclamationTriangle,
        colorClass: "guidance-callout--warning",
    },
    info: {
        icon: faCircleInfo,
        colorClass: "guidance-callout--info",
    },
    danger: {
        icon: faTimesCircle,
        colorClass: "guidance-callout--danger",
    },
    action: {
        icon: faCheckCircle,
        colorClass: "guidance-callout--action",
    },
};

/**
 * GuidanceCallout - contextual, condition-driven guidance panel.
 *
 * @param {string}   variant    "warning" | "info" | "danger" | "action"
 * @param {object}   icon       FA icon override (optional)
 * @param {string}   title      Bold heading text
 * @param {string}   message    Explanatory sentence (optional)
 * @param {string[]} steps      Numbered list of "what to do" instructions (optional)
 * @param {Array}    actions    [{label, onClick, variant}] CTA buttons (optional)
 */
const GuidanceCallout = ({
    variant = "warning",
    icon,
    title,
    message,
    steps,
    actions,
}) => {
    const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.warning;
    const resolvedIcon = icon || config.icon;

    return (
        <div className={`guidance-callout ${config.colorClass} mt-2`} role="alert">
            <div className="guidance-callout__icon-col">
                <FontAwesomeIcon icon={resolvedIcon} className="guidance-callout__icon" />
            </div>
            <div className="guidance-callout__body">
                {title && <div className="guidance-callout__title">{title}</div>}
                {message && <div className="guidance-callout__message">{message}</div>}
                {steps?.length > 0 && (
                    <ol className="guidance-callout__steps">
                        {steps.map((step, i) => (
                            <li key={i}>{step}</li>
                        ))}
                    </ol>
                )}
                {actions?.length > 0 && (
                    <div className="guidance-callout__actions">
                        {actions.map(({ label, onClick, variant: btnVariant = "warning" }, i) => (
                            <button
                                key={i}
                                type="button"
                                className={`btn btn-sm btn-${btnVariant} guidance-callout__action-btn`}
                                onClick={onClick}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GuidanceCallout;
